<div class="card">
    <slot></slot>
</div>

<style>
    .card {
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        padding: 20px;
        margin: 10px 0;
    }
</style>